<script lang="ts">
	import type { PageData } from './$types';
	import inView from '$lib/actions/inView';
	import { onMount } from 'svelte';
	import { useStoryblokBridge } from '@storyblok/svelte';
	import { getCMSComponents } from '@app/components/cms';
	export let data: PageData;

	onMount(async () => {
		if (data.story) {
			useStoryblokBridge(
				data.story.id,
				async (newStory) => {
					data.FullCMSComponents = await getCMSComponents(newStory.content.body);
				},
				{
					preventClicks: true
				}
			);
		}
	});

	// $: sections = data.story?.body?.map((comp) => {
	// 	return {
	// 		comp: comp,
	// 		isInview: false
	// 	};
	// });

	// $: console.log(sections);

	// const getSectionClassNames = (s) => {
	// 	let classNames = 'opacity-0 transition-opacity transition-transform translate-y-6';
	// 	if (s.comp.component === 'stats') {
	// 		classNames += ' overflow-hidden';
	// 	}
	// 	if (s.isInview) {
	// 		classNames += ' inView';
	// 	}
	// 	return classNames;
	// };
</script>

{#if data.FullCMSComponents.length}
	{#each data.FullCMSComponents as comp}
		<section
			use:inView={comp}
			on:enterViewport={() => (comp.isInview = true)}
			class={comp.CMSComp.component === 'stats' ? 'overflow-hidden' : ''}
		>
			<svelte:component this={comp.svelteComp} blok={comp.CMSComp} />
		</section>
	{/each}
{/if}

<style lang="postcss">
	section.inView {
		@apply opacity-100 translate-y-0;
		transition:
			transform 500ms 300ms,
			opacity 500ms 200ms;
	}
</style>
